import __reduce from 'lodash/reduce';

//import { isNoticiesPath } from 'utils/pathHelper';
import { trescatComponents } from './3cat/';
import { trescatinfoComponents } from './3catinfo/';
import { esadirComponents } from './esadir/';
import { corporatiuComponents } from './corporatiu/';
import { baseComponents } from './base';

const COMPONENTSBYSITE = {
    '3catinfo': trescatinfoComponents,
    '3cat': trescatComponents,
    'esadir': esadirComponents,
    'corporatiu': corporatiuComponents
};

const extractDynamicComponents = (components) =>
    __reduce(
        components,
        (memo, component, key) => {
            memo[key] = component.dynamicComponent;
            return memo;
        },
        {}
    );


const AllComponents = trescatComponents;

const DynamicComponents = {
    ...extractDynamicComponents(baseComponents),
    ...extractDynamicComponents(AllComponents),
};

const getDynamicComponents = (site) => {
    const siteComponents = COMPONENTSBYSITE[site] || {};

    const baseDynamic = extractDynamicComponents(baseComponents);
    const siteDynamic = extractDynamicComponents(siteComponents);

    return {
        ...baseDynamic,
        ...siteDynamic,
    };
};

export { AllComponents, DynamicComponents, getDynamicComponents };
